import {useIntl} from 'react-intl'
import {formatPhoneNumber} from '../../utils/phone-utils'

export default function useCommunicationsFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const fields = {
        emailGarageOptIn: {
            name: `${prefix}emailGarageOptIn`,
            label: formatMessage({
                id: 'communication_preferences.email.general.label',
                defaultMessage: 'General Email Preferences'
            }),
            type: 'radio',
            options: [
                {
                    label: formatMessage({
                        id: 'communication_preferences.email.subscribe',
                        defaultMessage: 'Subscribe'
                    }),
                    value: 'true'
                },
                {
                    label: formatMessage({
                        id: 'communication_preferences.email.unsubscribe',
                        defaultMessage: 'Unsubscribe'
                    }),
                    value: 'false'
                }
            ],
            rules: {
                required: formatMessage({
                    id: 'communication_preferences.email.required',
                    defaultMessage: 'Please select an option'
                })
            },
            error: errors[`${prefix}emailGarageOptIn`],
            control,
            defaultValue: 'true'
        },

        emailGaragePersonalizedOptIn: {
            name: `${prefix}emailGaragePersonalizedOptIn`,
            label: formatMessage({
                id: 'communication_preferences.email.garage.label',
                defaultMessage: 'Garage Collectif Email Preferences'
            }),
            type: 'radio',
            options: [
                {
                    label: formatMessage({
                        id: 'communication_preferences.email.subscribe',
                        defaultMessage: 'Subscribe'
                    }),
                    value: 'true'
                },
                {
                    label: formatMessage({
                        id: 'communication_preferences.email.unsubscribe',
                        defaultMessage: 'Unsubscribe'
                    }),
                    value: 'false'
                }
            ],
            rules: {
                required: formatMessage({
                    id: 'communication_preferences.email.required',
                    defaultMessage: 'Please select an option'
                })
            },
            error: errors[`${prefix}emailGaragePersonalizedOptIn`],
            control,
            defaultValue: 'true'
        },

        smsPhoneNumber: {
            name: `${prefix}smsPhoneNumber`,
            type: 'tel',
            placeholder: formatMessage({
                id: 'communication_preferences.sms.phone_label',
                defaultMessage: 'Phone Number'
            }),
            rules: {
                required: formatMessage({
                    id: 'communication_preferences.sms.phone_required',
                    defaultMessage: 'Phone number is required'
                }),
                pattern: {
                    value: /^[+]?[(]?[\d\s\-\(\)]{10,}$/,
                    message: formatMessage({
                        id: 'communication_preferences.sms.phone_invalid',
                        defaultMessage: 'Please enter a valid phone number'
                    })
                }
            },
            error: errors[`${prefix}smsPhoneNumber`],
            control,
            inputProps: ({onChange}) => ({
                inputMode: 'numeric',
                onChange(evt) {
                    onChange(formatPhoneNumber(evt.target.value))
                }
            }),
            hideLabel: true
        }
    }

    return fields
}
